export default "__VITE_ASSET__BCIhGHLw__"